<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    height="300px"
    :title="`Cập nhật ${$t('sidebar.symbol.name')}`"
    width="400px"
  >
    <div id="app" style="height: 450px">
      <div style="text-align: center">
        Dung lượng tối đa là 1MB. Chỉ hỗ trợ: PNG, JPEG, JPG
      </div>
      <div v-if="img" class="pt-4" @click="goUpload">
        <div
          class="d-flex align-center justify-center mb-8"
          style="width: 100%"
        >
          <div class="image-select d-flex align-center justify-center">
            <v-img :src="img" style="max-height: 220px; max-width: 220px" />
          </div>
        </div>
      </div>
      <v-text-field
        v-model="imageForm.name"
        :rules="rules"
        counter="50"
        label="Tên hình ảnh, ký hiệu"
      ></v-text-field>
      <div>Định dạng: {{ imageForm.file_type }}</div>
      <div v-if="!img" class="avatar_null" @click="goUpload">
        <div>
          <v-icon>mdi-image</v-icon>
        </div>
        <v-card-subtitle v-if="errortext" class="pt-0 error--text">
          {{ errortext }}
        </v-card-subtitle>
      </div>
      <input
        :id="cbId"
        accept="image/png,image/jpeg,image/jpg"
        style="display: none"
        type="file"
        @change="onFileChange"
      />
    </div>
    <template #extra-btn>
      <base-button v-if="img" color="primary" @click="Upload"
        >Cập nhật</base-button
      >
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { mapGetters } from 'vuex'
import { API_SYMBOL } from '@api'

export default {
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    img: '',
    cbId: '',
    file: null,
    errortext: '',
    imageArray: [],
    formData: null,
    imageForm: {},
    rules: [(v) => v.length <= 50 || 'Tên tối đa 50 ký tự'],
  }),
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
  },
  watch: {
    dialog: {
      handler(value) {
        this.show = value
      },
      immediate: true,
    },
    show(value) {
      if (!value) this.$emit('close')
    },
  },
  mounted() {
    this.cbId = Math.random().toString(16).slice(2)
  },
  methods: {
    open(item) {
      this.cbId = Math.random().toString(16).slice(2)
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.imageForm = { ...item }
      this.$set(this.imageForm, Object.assign(item))
      this.img = item.patch
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
      this.img = ''
      this.cbId = Math.random().toString(16).slice(2)
      this.file = null
      this.errortext = ''
    },
    getData() {
      this.$emit('reset')
    },
    async onFileChange(e) {
      let img = e.target.files[0]
      let imagerrors = 0
      let data = new FormData()
      this.errortext = ''
      const typeImage = ['image/jpeg', 'image/png', 'image/jpg']
      if (!img) return

      if (img.size > 1 * 1024 * 1024) {
        this.errortext = 'Chỉ chập nhận tập tin dưới 1MB'
        return
      }
      if (!typeImage.includes(img.type)) {
        this.errortext = 'Định dạng ảnh không hợp lệ'
        return
      }
      let image = new Image()
      let vm = this
      image.onload = function () {
        if (this.width) {
          var reader = new FileReader()
          reader.readAsDataURL(img)
          reader.onload = (e) => {
            let name = img.name.split('.')[0]
            vm.img = e.target.result
            vm.imageArray.push({ src: vm.img, name: name })
          }
        }
      }
      image.onerror = () => {
        imagerrors++
        this.errortext = imagerrors + ' tập tin không đúng dịnh dạng hình ảnh'
      }
      data.append('file', img)
      let res = await API_SYMBOL.updateImage(data, (e) => {})
      if (res.isDone) {
        this.img = res.data.link
        this.imageForm.patch = res.data.link
        this.imageForm.size = res.data.size
      }
    },
    goUpload() {
      document.getElementById(this.cbId).click()
    },
    close() {
      this.show = false
      this.$emit('close')
      this.imageArray = []
    },
    async Upload() {
      let res = await API_SYMBOL.updateIcon(this.imageForm, this.imageForm.id)
      if (res && !res.error) {
        this.onDialogClose()
        this.getData()
      }
    },
    removeImage(src) {
      let indexImg = this.imageArray.indexOf(src)
      if (indexImg > -1) {
        this.imageArray.splice(indexImg, 1)
      }
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}

.image-box {
  height: 120px;
  width: 120px;
  border: 1px solid #cacfd2;
  position: relative;
}
.image-select {
  height: 250px;
  width: 250px;
  border: 1px solid #1f618d;
  cursor: pointer;
}
.image-select:hover {
  border: 1px solid #3498db;
}
</style>
